document.addEventListener('scroll', () => {
  const hero = document.querySelector('.hero');
  if (!hero) return;

  if (window.scrollY > 80) {
    document.body.classList.add('hero-scrolled');
  } else {
    document.body.classList.remove('hero-scrolled');
  }
});
